/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-22 19:27:22
 * @LastEditTime: 2022-03-17 15:50:48
 * @LastEditors: chenguobiao
 */
import { strictFetch } from './http'
import qs from 'qs'
export async function checkUserTestQualifications(params) {
  return strictFetch({
    url: '/testUser/checkUserTestQualifications',
    method: 'POST',
    params,
  })
}
// 获取考试记录
export async function getTestLogList(params) {
  return strictFetch({
    url: '/userTestLog/getList',
    method: 'GET',
    params,
  })
}

// 考卷保存
export async function saveTestLog(params) {
  return strictFetch({
    url: '/userTestLog/save',
    method: 'POST',
    params,
  })
}

// 公告列表
export async function getMessageList(params) {
  return strictFetch({
    url: '/message/getList',
    method: 'POST',
    params,
  })
}

// 申请考级和开始考级权限判断
export async function postCheckUserApplyTestPermission(data) {
  return strictFetch({
    url: '/index/checkUserApplyTestPermission',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 开始考级时获取试卷信息及订单信息
export async function postGetTestPaper(data) {
  return strictFetch({
    url: '/index/getTestPaper',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 申请考级时获取信息
export async function postGetApplyProductInfo(data) {
  return strictFetch({
    url: '/index/getApplyProductInfo',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 申请考级时获取信息
export async function postRepeatApplyTestPermission(data) {
  return strictFetch({
    url: 'index/repeatApplyTestPermission',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 域名判断权限类型
export async function postLoginJudgeSource(data) {
  return strictFetch({
    url: '/login/judgeSource',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 根据code登录跳转是否跳转补录页和首页面
export async function postLoginByCode(data) {
  return strictFetch({
    url: '/login/loginByCode',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 调用更新视频观看次数
export async function postUpdateVideoTimes(data) {
  return strictFetch({
    url: '/index/updateVideoTimes',
    method: 'POST',
    data: qs.stringify(data)
  })
}
export async function postApplyFreeProduct(data) {
  return strictFetch({
    url: '/index/applyFreeProduct',
    method: 'POST',
    data
  })
}
